<div [ngStyle]="{ width: width, height: height, 'background-color': getBackgroundColor() }"></div>
